import api from './api';

const API_PREFIX = "api/validation";

const getValidationsData = async (params) => {
    const response = await api.get(`${API_PREFIX}/list`, { params });
    return response;
};

const mergeValidationData = async (params) => {
    const response = await api.post(`${API_PREFIX}/merge`, params);
    return response;
};

const moveValidationOption = async (params) => {
    const response = await api.post(`${API_PREFIX}/move`, params);
    return response;
};

export {
    getValidationsData,
    mergeValidationData,
    moveValidationOption
};
